<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-card class="mb-1">
          <v-card-title>
            <span class="homeTop">Seller Offer Verification</span>
            <v-spacer></v-spacer>
          </v-card-title>
        </v-card>
        <v-layout wrap justify-start v-if="list.length > 0">
          <v-flex v-for="(item, i) in list" :key="i" md3 pa-4>
            <v-card style="line-height: 16px">
              <v-img
                v-if="item.photo"
                style="width: 100%; object-fit: contain; cursor: pointer"
                :src="baseURL + '/file/get/' + item.photo"
                height="200px"
                cover
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="#FF2323"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-img
                v-else
                height="200px"
                src="./../../assets/images/noimage.png"
              ></v-img>
              <v-layout wrap justify-center px-2 py-4>
                <v-flex text-center xs12>
                  <span class="homeName"> {{ item.name }} </span><br />
                  <span
                    class="showLine text-center"
                    style="font-size: 13px; color: #000000"
                    v-html="item.description"
                  >
                  </span>
                  <!-- <br/> -->
                  <!-- <span>{{item.starting.slice(0,10)}} - {{item.ending.slice(0,10)}}</span><br/><br/>
                  <span>{{item.starting.slice(11,16)}} - {{item.ending.slice(11,16)}}</span> -->
                </v-flex>
                <v-flex
                  text-center
                  pt-5
                  xl6
                  lg12
                  md12
                  pb-2
                  sm6
                  xs6
                  px-5
                  justify-center
                >
                  <v-btn block outlined color="green" @click="editSlider(item)"
                    >Edit</v-btn>
                </v-flex>
                <v-flex
                  text-center
                  pt-5
                  xl6
                  lg12
                  md12
                  pb-2
                  sm6
                  xs6
                  px-5
                  justify-center
                >
                  <v-btn
                    block
                    outlined
                    color="primary"
                    @click="approveOffer(item)"
                    >Approve Offer</v-btn
                  >
                </v-flex>
                <v-flex
                  text-center
                  pt-5
                  xl6
                  lg12
                  md12
                  pb-2
                  sm6
                  xs6
                  px-5
                  justify-center
                >
                  <template>
                    <v-dialog v-model="rejectdialog" max-width="600px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          block
                          v-on="on"
                          v-bind="attrs"
                          outlined
                          color="red"
                          >Reject Offer</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title class="headline grey lighten-2">
                          Delete Confirmation
                        </v-card-title>
                        <v-card-text style="padding-bottom: 0px">
                          <v-col cols="12">
                            <span style="font-size: 16px; font-weight: 600"
                              >Please confirm that you want to Remove this
                              Offer?
                            </span>
                            <v-text-field
                              outlined
                              dense
                              v-model="remark"
                              label="Remark"
                            >
                            </v-text-field>
                          </v-col>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="error" @click="rejectdialog = false"
                            >Cancel</v-btn>
                          <v-btn color="primary" @click="rejectOffer(item)"
                            >Reject</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout v-else justify-center wrap pt-5>
          <v-flex xs12 text-center>
            <span class="homeText">No Data Found.....</span>
          </v-flex>
        </v-layout>
        <v-dialog v-model="editdialog" max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline">Edit Offer</span>
            </v-card-title>
            <v-card-text>
              <v-layout justify-center wrap>
                <v-flex xs12>
                  <v-text-field
                    class="homeText"
                    outlined
                    dense
                    v-model="editingitem.name"
                    label="Name of the Team Member"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="editingitem.cities"
                    :items="cityArray"
                    item-text="name"
                    item-value="value"
                    item-color="#8d8d8d"
                    color="#8d8d8d"
                    outlined
                    multiple
                    dense
                    label="Select City"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <span class="homeText">Description of the Offer</span>
                  <div id="app">
                    <vue-editor v-model="editingitem.description"></vue-editor>
                  </div>
                </v-flex>
                <v-flex md12 xs12 py-5>
                  <ImageCom
                    @stepper="winStepper"
                    :singleImage="editingitem.photo"
                    :heading="'Upload Image'"
                    :componentType="'topimage'"
                  />
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editingitem.startingDate"
                        label="From Date"
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editingitem.startingDate"
                      no-title
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md3 pl-2>
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editingitem.endingDate"
                        label="To Date"
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editingitem.endingDate"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md3 pl-2>
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="editingitem.startingTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editingitem.startingTime"
                        label="Starting Time"
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu3"
                      v-model="editingitem.startingTime"
                      full-width
                      @click:minute="$refs.menu3.save(editingitem.startingTime)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md3 pl-2>
                  <v-menu
                    ref="menu4"
                    v-model="menu4"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="editingitem.endingTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editingitem.endingTime"
                        label="Ending Time"
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu4"
                      v-model="editingitem.endingTime"
                      full-width
                      @click:minute="$refs.menu4.save(editingitem.endingTime)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="editdialog = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="edit(editingitem._id)">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <div class="text-center pb-5" v-if="pages > 1">
      <v-pagination
        :length="pages"
        :total-visible="7"
        v-model="currentPage"
        color="red"
      ></v-pagination>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ImageCom from "@/components/commonComponents/singleImage";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    ImageCom,
    VueEditor,
  },
  data() {
    return {
      startingDate: new Date(),
      endingDate: new Date(),
      startingTime: "",
      endingTime: "",
      list: [],
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dialog: false,
      remark: "",
      editingitem: [],
      city: null,
      cityArray: [],
      editdialog: false,
      ServerError: false,
      showSnackBar: false,
      appLoading: false,
      timeout: 5000,
      msg: null,
      formData: new FormData(),
      selectedFiles: [],
      image: null,
      imagePreview: "",
      showPreview: false,
      file: null,
      coverImageArray: [],
      formDataCover: new FormData(),
      id: null,
      rejectdialog: false,
      page: 1,
      currentPage: 1,
      pages: 12,
      limit: 12,
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
    this.getPlace();
  },
  methods: {
    winStepper(window_data) {
      if (window_data.type == "topimage") {
        this.topimageFile = window_data.selectedFiles;
      }
    },
    getList() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/admin/seller/offer/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          userid: this.$route.query.seller,
          offerStatus: "pending",
          limit: this.limit,
          page: this.currentPage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.list = response.data.data;
          this.pages = Math.ceil(response.data.totalLength / this.limit);
        })
        .catch((err) => {
          (this.appLoading = false), (this.ServerError = true);
          console.log(err);
        });
    },
    approveOffer(id) {
      this.appLoading = true;
      axios({
        url: "/admin/offer/approve/reject",
        method: "POST",
        data: {
          id: id._id,
          action: "approve",
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Offer Approval Complete!";
            this.showSnackBar = true;
            this.getList();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    rejectOffer(r) {
      this.rejectdialog = false;
      this.appLoading = true;
      axios({
        url: "/admin/offer/approve/reject",
        method: "POST",
        data: {
          id: r._id,
          action: "reject",
          rejectReason: this.remark,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Offer Deleted";
            this.showSnackBar = true;
            this.getList();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSlider(item) {
      this.editingitem = item;
      this.editingitem.startingDate = this.editingitem.starting.slice(0, 10);
      this.editingitem.endingDate = this.editingitem.ending.slice(0, 10);
      this.editingitem.startingTime = this.editingitem.starting.slice(11, 16);
      this.editingitem.endingTime = this.editingitem.ending.slice(11, 16);
      this.editdialog = true;
    },
    getPlace() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/sellers/city/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.cityArray = response.data.data;
          // var temp = [
          //   {
          //     name: null,
          //     value: null,
          //   },
          // ];
          // temp = response.data.data;
          // for (var i = 0; i < temp.length; i++) {
          //   temp[i].name = temp[i].name;
          //   temp[i].value = temp[i]._id;
          // }
          // this.placeArray = temp;
          // this.placeArray.unshift({ name: "All", value: null });
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    edit() {
      this.appLoading = true;
      this.formDataCover.append("name", this.editingitem.name);
      this.formDataCover.append("cities", this.editingitem.cities);
      this.formDataCover.append("description", this.editingitem.description);
      this.formDataCover.append("startingDate", this.editingitem.startingDate);
      this.formDataCover.append("startingTime", this.editingitem.startingTime);
      this.formDataCover.append("endingDate", this.editingitem.endingDate);
      this.formDataCover.append("endingTime", this.editingitem.endingTime);
      this.formDataCover.append("photo", this.topimageFile);
      this.formDataCover.append("id", this.editingitem._id);
      axios({
        method: "POST",
        url: "/admin/seller/offer/edit",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.formDataCover,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.getList();
          } else {
            this.msg = "Can't Update";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>